/**
 * Created by natitessema on 4/11/17.
 */
const BS_SM_MAX_WIDTH = 767

export function isMobileScreenSize() {
    return window.innerWidth < BS_SM_MAX_WIDTH
}
